export enum VerificationStatusEnum {
  VERIFICATION_SUCCESS = 'VERIFICATION_SUCCESS',
  VERIFICATION_FAILED = 'VERIFICATION_FAILED',
  NOT_READY = 'NOT_READY',
  VERIFICATION_PENDING = 'VERIFICATION_PENDING',
}

export enum ExemptionReasonEnum {
  PURPOSE_RESALE = 'PURPOSE_RESALE',
  ENTITY_TYPE_NONPROFIT = 'ENTITY_TYPE_NONPROFIT',
  GOVERNMENT = 'GOVERNMENT',
  MANUFACTURER = 'MANUFACTURER',
  AGRICULTURAL = 'AGRICULTURAL',
  OTHER = 'OTHER',
}

export enum ExemptionStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum CertificateTypeEnum {
  MTC = 'MTC',
  SST = 'SST',
  SINGLE_STATE = 'SINGLE_STATE',
}

export enum ExemptionIdTypeEnum {
  FEIN = 'FEIN',
  TIN = 'TIN',
  DL = 'DL',
  OTHER = 'OTHER',
}
